import { useLocation } from 'react-router-dom';
import { DinteroErrorTypes } from '../types/dinteroPayment';

/**
 * Provider-aware detection of a payment-provider return redirect.
 *
 * Stripe hosted Checkout redirects back with `payment_provider=stripe` and a
 * `payment_status` of `success` | `cancelled` (set by the backend success/cancel
 * URLs). Dintero returns with its own `transaction_id` / `error` query params.
 * The `error` shape is shared so `getErrorTextBasedOnErrorType` works for both.
 */
export const useIsPaymentSuccessful = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  if (searchParams.get('payment_provider') === 'stripe') {
    const paymentStatus = searchParams.get('payment_status');
    return {
      error: paymentStatus === 'cancelled' ? 'cancelled' : 'failed',
      isPaymentSuccessful: paymentStatus === 'success'
    };
  }

  const transactionId = searchParams.get('transaction_id');
  const error = searchParams.get('error') as DinteroErrorTypes;

  return {
    error,
    isPaymentSuccessful: Boolean(transactionId) && error !== 'capture'
  };
};
